module.exports = __webpack_public_path__ + "static/media/mafia.27ce624d.png";